import action from '../../../abstract/action.js';

export default action({
  label: 'Edytuj',
  icon: 'EditIcon',
  main: () => true,
  render: ({ item }) => item.id !== null,
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'admin-work-parameters-edit', params: { id } }),
});
